<template>
    <inertia-head>
        <title>{{ title }}</title>
        <link rel="canonical" :href="canonical">
        <meta name="description" :content="`Grymma rabatter och erbjudanden hos ${desc}! 1000-tals rabattkoder till lokala och rikstäckande företag!`">
        <meta name="og:title" :content="`Rabattkoder ifrån ${company.name}`">
        <meta v-if="!images.company_first_image" property="og:image" :content="`${$page.props.baseUrl}/assets/frontend/placeholder4-3.jpg`">
        <meta v-else property="og:image" :content="images.company_first_image">
    </inertia-head>

    <div class="company:page">
        <breadcrumb>
            <breadcrumb-item>
                <inertia-link href="/">Hem</inertia-link>
            </breadcrumb-item>
            <breadcrumb-item :last="true">
                {{ company.name }}
            </breadcrumb-item>
        </breadcrumb>

        <main role="main" class="main company container" v-bind:class="{ container: !$isMobile }">
            <h1 class="text-red page-heading company:name-heading" style="margin-top: 65px;">{{ company.name }}</h1>

            <div class="row row-container-1" style="padding: 25px 0px;">
                <div class="col-12 col-md-6 m-0 pr-0 row-1">
                    <div v-if="images.company_first_image" class="cimagecontainer4-3"
                        :style="{ 'background-image': 'url(' + images.company_first_image + ')' }">
                    </div>
                    <img v-else src="/assets/frontend/placeholder4-3.jpg" class="w-100">

                    <div class="logo-rounded d-md-none company-logo-mobile">
                        <span>
                            <img v-if="images.company_logo_image" :src="images.company_logo_image" :alt="`${company.name} Logga`"  :title="company.name">
                        </span>
                    </div>
                </div>
                <div class="col-12 col-md-6 m-0 p-md-0 p-5 row-2 relative">
                    <div class="row-inner">
                        <div class="comphead" style="font-size: 16px; font-family: AvertaRegular; font-weight: 700; color: #444; text-transform: uppercase; margin-bottom: 15px;">{{ company.heading }}</div>
                        <expandable-text v-if="company.info?.length" :disabled="!$isMobile" class="company-html-info">{{company.info}}</expandable-text>
                    </div>

                    <div class="keywords">{{ company.keywords }}</div>
                </div>

                <div class="col-12 col-md-6 m-0 p-5 row-3 flex flex-col">
                    <div class="mb-3">
                        <div class="text-uppercase font-weight-bold mt-5" style="margin-top: 48px; margin-bottom: 15px;font-size: 16px; color: #444; font-weight: 700; font-family: AvertaRegular;">Kontakta {{ company.name }}</div>

                        <table>
                            <tr v-if="publicUrl">
                                <td><strong>{{ $t('web') }}</strong>:</td>
                                <td><a :href="publicUrl" :rel="`${company.follow_links ? '' : 'nofollow' } external`" target="_blank" class="text-dark pl-2"><u>Klicka här</u> </a></td>
                            </tr>

                            <tr v-if="company.public_phone_number">
                                <td><strong>{{ $t('telephone') }}</strong>:</td>
                                <td><a :href="'tel:' + company.public_phone_number" class="text-dark pl-2" rel="nofollow external"> <u>{{ company.public_phone_number }}</u> </a></td>
                            </tr>

                            <tr v-if="company.public_email_address">
                                <td><strong>{{ $t('email') }}</strong>:</td>
                                <td><a :href="'mailto:' + company.public_email_address" class="text-dark pl-2" rel="nofollow external"> <u>{{ company.public_email_address }}</u> </a></td>
                            </tr>
                        </table>

                        <!-- <span class="d-block" v-if="publicUrl"><strong>{{ $t('web') }}</strong>: <a :href="publicUrl" :rel="`${company.follow_links ? '' : 'nofollow' } external`" target="_blank" class="text-dark"><u>Klicka här</u> </a> </span> -->

                        <!-- <span class="d-block" v-if="company.public_phone_number"><strong>{{ $t('telephone') }}</strong>: <a :href="'tel:' + company.public_phone_number" class="text-dark" rel="nofollow external"> {{ company.public_phone_number }} </a> </span>
 -->
                        <!-- <span class="d-block" v-if="company.public_email_address"><strong>{{ $t('email') }}</strong>:  <a :href="'mailto:' + company.public_email_address" class="text-dark" rel="nofollow external"> <u>{{ company.public_email_address }}</u> </a> </span> -->
                    </div>

                    <div>
                        <a v-if="company.fb_url" :href="company.fb_url" class="text-black" style="color: #4267B2 !important;display: inline-block;" rel="nofollow external">
                            <i class="fab fa-facebook fa-2x"></i>
                        </a>

                        <a v-if="company.ig_url" :href="company.ig_url" class="text-black" rel="nofollow external" style="display: inline-block;">
                            <i class="fab fa-instagram fa-2x ml-1" style=" background: #d6249f; background: radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%);  -webkit-background-clip: text; -webkit-text-fill-color: transparent;"></i>
                        </a>
                    </div>

                    <!-- <div class="share-buttons mb-3">
                        <a class="btn btn-danger w-50">Bli medlem</a>
                    </div> -->

                    <div class="mt-auto">
                        <template v-for="companyCity in companyCities">
                            <inertia-link v-if="isShowingCity(companyCity.city_id)" :href="`/${company.slug}`" :key="companyCity.city_id">
                                <span
                                    class="badge badge-danger mr-1">
                                    {{ companyCity.city.name }}
                                </span>
                            </inertia-link>
                            <inertia-link v-else :key="companyCity.city_id" :href="`/${company.slug}/${companyCity.city.slug}`">
                                <span
                                    class="badge mr-1">
                                    {{ companyCity.city.name }}
                                </span>
                            </inertia-link>
                        </template>
                    </div>
                </div>

                <div class="col-12 col-md-6 m-0 px-0 row-4">
                    <div class="company-logo-desktop logo-rounded">
                        <span>
                            <img v-if="images.company_logo_image" :src="images.company_logo_image" class="w-100"  :alt="`${company.name} Logga`" :title="company.name">
                        </span>
                    </div>
                     <div
                        v-if="images.company_second_image"
                        class="cimagecontainer4-3"
                        :style="{ 'background-image': 'url(' + images.company_second_image + ')' }">
                    </div>
                     <img v-else src="/assets/frontend/placeholder4-3.jpg" class="w-100">
                </div>
            </div>
        </main>
    </div>

    <div class="container-fluid py-4" style="background:#e4f4fb;" v-if="campaigns && campaigns.length">
        <h1 class="text-center red mb-4" style="font-weight: 400; font-family: AvertaRegular; font-size: 22px; margin: 0; text-transform: none;">Erbjudanden från {{ company.name }}</h1>

        <campaign-component
            v-for="campaign in campaigns"
            :key="campaign.slug"
            :campaignSlug="campaign.slug"
            :campaign="campaign"
            :company="{...images, ...company}">
        </campaign-component>
    </div>
</template>

<style>
    .company-html-info li > p {
        margin: 0!important;
    }
</style>

<script>
    export default {
        props: ['company', 'companyCities', 'images', 'campaigns', 'showingCity', 'canonical'],
        inject: ['$isMobile'],
        created() {
            this.company.images = this.images;
        },
        mounted() {
            window.scrollTo(0, 0);
        },
        computed: {
            publicUrl() {
                let url = this.company.public_url;

                if (url && !url.startsWith('http') && !url.startsWith('https')) {
                    url = `http://${url}`;
                }

                return url;
            },
            title() {
                var title = this.company.name ? `Rabattkoder från ${this.company.name}` : null;

                if (this.showingCity) {
                    title += ` i ${this.showingCity.name}`;
                }

                return title;
            },

            desc() {
                var desc = this.company.name;

                if (this.showingCity) {
                    desc += ` i ${this.showingCity.name}`;
                }

                return desc;
            }
        },
        methods: {
            isShowingCity (city_id) {
                return this.showingCity && this.showingCity.id === city_id;
            }
        }
    }
</script>
